// Alimenté par scripts/migrate-pi-icons.mjs, contrôlé par scripts/check-ng-icons.mjs.
import {
  heroAdjustmentsHorizontal,
  heroArchiveBox,
  heroArrowDown,
  heroArrowDownLeft,
  heroArrowDownTray,
  heroArrowLeft,
  heroArrowLeftCircle,
  heroArrowLeftEndOnRectangle,
  heroArrowPath,
  heroArrowRight,
  heroArrowRightCircle,
  heroArrowRightStartOnRectangle,
  heroArrowTopRightOnSquare,
  heroArrowTrendingUp,
  heroArrowUp,
  heroArrowUpRight,
  heroArrowUpTray,
  heroArrowUturnLeft,
  heroArrowsPointingIn,
  heroArrowsPointingOut,
  heroArrowsRightLeft,
  heroArrowsUpDown,
  heroBanknotes,
  heroBars3,
  heroBars3BottomLeft,
  heroBarsArrowDown,
  heroBarsArrowUp,
  heroBell,
  heroBellSlash,
  heroBolt,
  heroBookOpen,
  heroBookmark,
  heroBriefcase,
  heroBuildingLibrary,
  heroBuildingOffice,
  heroCalculator,
  heroCalendar,
  heroCalendarDays,
  heroCamera,
  heroChartBar,
  heroChartPie,
  heroChatBubbleLeft,
  heroChatBubbleLeftRight,
  heroCheck,
  heroCheckBadge,
  heroCheckCircle,
  heroChevronDoubleDown,
  heroChevronDoubleLeft,
  heroChevronDoubleRight,
  heroChevronDoubleUp,
  heroChevronDown,
  heroChevronLeft,
  heroChevronRight,
  heroChevronUp,
  heroCircleStack,
  heroClipboard,
  heroClock,
  heroCloud,
  heroCloudArrowDown,
  heroCloudArrowUp,
  heroCodeBracket,
  heroCog6Tooth,
  heroComputerDesktop,
  heroCreditCard,
  heroCube,
  heroCurrencyDollar,
  heroCurrencyEuro,
  heroCursorArrowRays,
  heroDocument,
  heroDocumentArrowDown,
  heroDocumentArrowUp,
  heroDocumentCheck,
  heroDocumentDuplicate,
  heroDocumentPlus,
  heroDocumentText,
  heroEllipsisHorizontal,
  heroEllipsisVertical,
  heroEnvelope,
  heroExclamationCircle,
  heroExclamationTriangle,
  heroEye,
  heroEyeSlash,
  heroFlag,
  heroFolder,
  heroFolderOpen,
  heroFolderPlus,
  heroForward,
  heroFunnel,
  heroGlobeAlt,
  heroGlobeEuropeAfrica,
  heroHandThumbDown,
  heroHandThumbUp,
  heroHashtag,
  heroHeart,
  heroHome,
  heroIdentification,
  heroInbox,
  heroInboxArrowDown,
  heroInformationCircle,
  heroKey,
  heroLightBulb,
  heroLink,
  heroListBullet,
  heroLockClosed,
  heroLockOpen,
  heroMagnifyingGlass,
  heroMagnifyingGlassMinus,
  heroMagnifyingGlassPlus,
  heroMap,
  heroMapPin,
  heroMinus,
  heroMinusCircle,
  heroMoon,
  heroNoSymbol,
  heroPaperAirplane,
  heroPaperClip,
  heroPause,
  heroPauseCircle,
  heroPencil,
  heroPencilSquare,
  heroPhone,
  heroPhoto,
  heroPlay,
  heroPlus,
  heroPlusCircle,
  heroPresentationChartLine,
  heroPrinter,
  heroQrCode,
  heroQuestionMarkCircle,
  heroReceiptPercent,
  heroShare,
  heroShieldCheck,
  heroShoppingBag,
  heroShoppingCart,
  heroSparkles,
  heroSpeakerWave,
  heroSquare2Stack,
  heroSquares2x2,
  heroStar,
  heroStop,
  heroSun,
  heroSwatch,
  heroTableCells,
  heroTag,
  heroTrash,
  heroTruck,
  heroUser,
  heroUserCircle,
  heroUserGroup,
  heroUserPlus,
  heroUsers,
  heroVideoCamera,
  heroViewColumns,
  heroWallet,
  heroWrench,
  heroWrenchScrewdriver,
  heroXCircle,
  heroXMark,
} from "@ng-icons/heroicons/outline";
import { heroBookmarkSolid, heroFlagSolid, heroFunnelSolid, heroStarSolid } from "@ng-icons/heroicons/solid";

import { EVA_ICONS } from "./eva-icons";

/** Icônes enregistrées à la racine de l'app, utilisables partout sans `provideIcons` local. */
export const APP_ICONS = {
  heroAdjustmentsHorizontal,
  heroArchiveBox,
  heroArrowDown,
  heroArrowDownLeft,
  heroArrowDownTray,
  heroArrowLeft,
  heroArrowLeftCircle,
  heroArrowLeftEndOnRectangle,
  heroArrowPath,
  heroArrowRight,
  heroArrowRightCircle,
  heroArrowRightStartOnRectangle,
  heroArrowTopRightOnSquare,
  heroArrowTrendingUp,
  heroArrowUp,
  heroArrowUpRight,
  heroArrowUpTray,
  heroArrowUturnLeft,
  heroArrowsPointingIn,
  heroArrowsPointingOut,
  heroArrowsRightLeft,
  heroArrowsUpDown,
  heroBanknotes,
  heroBars3,
  heroBars3BottomLeft,
  heroBarsArrowDown,
  heroBarsArrowUp,
  heroBell,
  heroBellSlash,
  heroBolt,
  heroBookOpen,
  heroBookmark,
  heroBookmarkSolid,
  heroBriefcase,
  heroBuildingLibrary,
  heroBuildingOffice,
  heroCalculator,
  heroCalendar,
  heroCalendarDays,
  heroCamera,
  heroChartBar,
  heroChartPie,
  heroChatBubbleLeft,
  heroChatBubbleLeftRight,
  heroCheck,
  heroCheckBadge,
  heroCheckCircle,
  heroChevronDoubleDown,
  heroChevronDoubleLeft,
  heroChevronDoubleRight,
  heroChevronDoubleUp,
  heroChevronDown,
  heroChevronLeft,
  heroChevronRight,
  heroChevronUp,
  heroCircleStack,
  heroClipboard,
  heroClock,
  heroCloud,
  heroCloudArrowDown,
  heroCloudArrowUp,
  heroCodeBracket,
  heroCog6Tooth,
  heroComputerDesktop,
  heroCreditCard,
  heroCube,
  heroCurrencyDollar,
  heroCurrencyEuro,
  heroCursorArrowRays,
  heroDocument,
  heroDocumentArrowDown,
  heroDocumentArrowUp,
  heroDocumentCheck,
  heroDocumentDuplicate,
  heroDocumentPlus,
  heroDocumentText,
  heroEllipsisHorizontal,
  heroEllipsisVertical,
  heroEnvelope,
  heroExclamationCircle,
  heroExclamationTriangle,
  heroEye,
  heroEyeSlash,
  heroFlag,
  heroFlagSolid,
  heroFolder,
  heroFolderOpen,
  heroFolderPlus,
  heroForward,
  heroFunnel,
  heroFunnelSolid,
  heroGlobeAlt,
  heroGlobeEuropeAfrica,
  heroHandThumbDown,
  heroHandThumbUp,
  heroHashtag,
  heroHeart,
  heroHome,
  heroIdentification,
  heroInbox,
  heroInboxArrowDown,
  heroInformationCircle,
  heroKey,
  heroLightBulb,
  heroLink,
  heroListBullet,
  heroLockClosed,
  heroLockOpen,
  heroMagnifyingGlass,
  heroMagnifyingGlassMinus,
  heroMagnifyingGlassPlus,
  heroMap,
  heroMapPin,
  heroMinus,
  heroMinusCircle,
  heroMoon,
  heroNoSymbol,
  heroPaperAirplane,
  heroPaperClip,
  heroPause,
  heroPauseCircle,
  heroPencil,
  heroPencilSquare,
  heroPhone,
  heroPhoto,
  heroPlay,
  heroPlus,
  heroPlusCircle,
  heroPresentationChartLine,
  heroPrinter,
  heroQrCode,
  heroQuestionMarkCircle,
  heroReceiptPercent,
  heroShare,
  heroShieldCheck,
  heroShoppingBag,
  heroShoppingCart,
  heroSparkles,
  heroSpeakerWave,
  heroSquare2Stack,
  heroSquares2x2,
  heroStar,
  heroStarSolid,
  heroStop,
  heroSun,
  heroSwatch,
  heroTableCells,
  heroTag,
  heroTrash,
  heroTruck,
  heroUser,
  heroUserCircle,
  heroUserGroup,
  heroUserPlus,
  heroUsers,
  heroVideoCamera,
  heroViewColumns,
  heroWallet,
  heroWrench,
  heroWrenchScrewdriver,
  heroXCircle,
  heroXMark,
  ...EVA_ICONS,
};
